import { SubsStatus } from "./SubsStatus";

export const SubsStatusLabels: Record<SubsStatus, string> = {
  active: "Assinante",
  trialing: "Período de teste",
  past_due: "Em atraso",
  incomplete: "Pagamento pendente",
  canceled: "Cancelado",
};
